@if (initialized && dto) {
    @if (uiMode == 'side') {
        <im-schema-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)" >
        </im-schema-side>
    } @else {
        <im-schema-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)" >
        </im-schema-full>
    }
}